import Image from "next/image";
import { Link } from "@/i18n/navigation";
import ButtonRightArrow from "@/assets/iconComponents/ButtonRightArrow";

/**
 * Card used in the "Fabriken: bakom kulisserna" home carousel.
 * Shows an event image with a "Läs mer" pill button overlaid top-right,
 * followed by a small event label and a title underneath.
 *
 * @param {Object} props
 * @param {string} props.image        — image URL or static import
 * @param {string} props.label        — small label above the title (e.g. "Event 030325")
 * @param {string} props.title        — card title
 * @param {string} props.readMoreText — text for the "Läs mer" pill
 * @param {string} props.route        — destination route
 * @param {boolean} props.unoptimized — pass true for remote (CMS) images
 */
function BehindTheScenesCard({ image, label, title, readMoreText, route, unoptimized }) {
  return (
    <Link href={route} className="flex flex-col w-full group">
      {/* Image with overlaid "Läs mer" button. Admins can upload any image, so
          we lock the card to the design's aspect ratio (626 × 417) and crop with
          object-cover, keeping the designed rounded corners (20/20/100/20). */}
      <div className="relative w-full md:w-[32.5vw] aspect-626/417 overflow-hidden rounded-tl-[20px] rounded-tr-[20px] rounded-bl-[20px] rounded-br-[60px] md:rounded-br-[100px]">
        <Image
          src={image}
          alt={title}
          fill
          sizes="(max-width: 768px) 90vw, (max-width: 1024px) 60vw, 45vw"
          unoptimized={unoptimized}
          loading="lazy"
          className="object-cover"
        />
        <span className="absolute top-[6%] right-4 md:top-5 md:right-5 inline-flex items-center gap-2 bg-ff-blue-80 text-ff-purple rounded-full px-2 py-0.5 md:px-4 md:py-1 text-[13px] md:text-[clamp(12px,0.9375vw,18px)] shadow-sm transition-colors group-hover:bg-ff-blue">
          {readMoreText}
          <ButtonRightArrow size={16} color="#5C2483" />
        </span>
      </div>

      {/* Label + title */}
      <div className="relative left-[8%] mt-2.5 md:mt-5 flex flex-col">
        <p className="text-ff-purple opacity-80 text-[16px]">{label}</p>
        <h3 className="text-ff-purple w-[70%] lg:w-[60%] text-[clamp(16px,5.58vw,30px)] leading-[130%] md:text-[clamp(20px,1.67vw,32px)] md:leading-[130%]">
          {title}
        </h3>
      </div>
    </Link>
  );
}

export default BehindTheScenesCard;
